export function formatNumber(num: number) {
  num = Math.round(num)
  return num
}
